import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
};

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const joinWaitlist = (email, invite, ref) => axios.post(`${API}/waitlist`, { email, ...(invite && { invite }), ...(ref && { ref }) });
export const createShare = (email, family_name) => axios.post(`${API}/share`, { email, family_name: family_name || null });
export const fetchShare = (token) => axios.get(`${API}/share/${encodeURIComponent(token)}`);
export const submitStory = (body) => axios.post(`${API}/stories`, body);
export const fetchStories = () => axios.get(`${API}/stories`);
export const fetchAdminStories = (token) => axios.get(`${API}/admin/stories`, { headers: authHeaders(token) });
export const addAdminStory = (token, body) => axios.post(`${API}/admin/stories`, body, { headers: authHeaders(token) });
export const setStoryStatus = (token, id, status) => axios.patch(`${API}/admin/stories/${id}`, { status }, { headers: authHeaders(token) });
export const deleteStory = (token, id) => axios.delete(`${API}/admin/stories/${id}`, { headers: authHeaders(token) });
export const fetchCount = () => axios.get(`${API}/waitlist/count`);
export const fetchInvite = (token) => axios.get(`${API}/invites/${encodeURIComponent(token)}`);
export const sendInvite = (inviter_email, partner_email) => axios.post(`${API}/waitlist/invite`, { inviter_email, partner_email });
export const fetchLaunch = (token) => axios.get(`${API}/admin/launch`, { headers: authHeaders(token) });
export const sendLaunch = (token) => axios.post(`${API}/admin/launch/send`, null, { headers: authHeaders(token) });
export const fetchEmailQueue = (token) => axios.get(`${API}/admin/email-queue`, { headers: authHeaders(token) });
export const fetchStoreLinks = () => axios.get(`${API}/store-links`);
export const fetchAdminStoreLinks = (token) => axios.get(`${API}/admin/store-links`, { headers: authHeaders(token) });
export const saveStoreLinks = (token, links) => axios.put(`${API}/admin/store-links`, links, { headers: authHeaders(token) });
export const fetchSneakPeek = (token) => axios.get(`${API}/admin/sneak-peek`, { headers: authHeaders(token) });
export const sendSneakPeek = (token) => axios.post(`${API}/admin/sneak-peek/send`, null, { headers: authHeaders(token) });
export const uploadScreenshot = (token, file) => {
  const form = new FormData();
  form.append("file", file);
  return axios.post(`${API}/admin/sneak-peek/screenshots`, form, { headers: authHeaders(token) });
};
export const deleteScreenshot = (token, id) => axios.delete(`${API}/admin/sneak-peek/screenshots/${id}`, { headers: authHeaders(token) });
export const adminLogin = (password) => axios.post(`${API}/admin/login`, { password });
export const fetchSignups = (token) => axios.get(`${API}/admin/signups`, { headers: authHeaders(token) });
export const exportSignups = (token) =>
  axios.get(`${API}/admin/signups/export`, { headers: authHeaders(token), responseType: "blob" });
